/**
 * Standard Image Size Constants
 * Consolidates all image dimensions across the application
 */

export const IMAGE_SIZES = {
  // Logo sizes
  logo: {
    sidebar: { width: 36, height: 36 },
    header: { width: 48, height: 48 },
    card: { width: 60, height: 60 },
    large: { width: 80, height: 80 },
  },

  // Avatar sizes
  avatar: {
    small: { width: 32, height: 32 },
    medium: { width: 48, height: 48 },
    large: { width: 64, height: 64 },
    xlarge: { width: 96, height: 96 },
  },

  // Background images
  background: {
    login: {
      minHeight: '100vh',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    page: {
      minHeight: '100vh',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      opacity: 0.05, // Very subtle background
    },
  },

  // Icon sizes
  icon: {
    small: { width: 16, height: 16 },
    medium: { width: 24, height: 24 },
    large: { width: 32, height: 32 },
  },
};

// Standard spacing for image containers
export const IMAGE_SPACING = {
  logoMargin: 1.5,
  avatarMargin: 1,
  iconMargin: 0.5,
};
